import type {
	ShipmentFreightDetails,
	ShipmentLineItem,
	ShipmentManagementPickupDeliveryDetails,
} from "~/shared/schemas/shipment-management-schema";

export const DELIVERY_SPECIAL_INSTRUCTIONS_DEFAULT =
	"No Delivery Instructions Provided.";
export const SPECIAL_INSTRUCTIONS_DEFAULT = "No Special Instructions Provided.";

export const PICKUP_DELIVERY_DETAILS_DEFAULT: ShipmentManagementPickupDeliveryDetails =
	{
		shipmentHoursFrom: null,
		shipmentHoursTo: null,
		shipmentNumber: null,
		companyName: null,
		address: null,
		locationType: null,
		contact: {
			name: null,
			phone: null,
			extension: null,
			email: null,
		},
		scheduled: null,
		actual: null,
		specialInstructions: null,
		appointmentType: null,
		accessorials: null,
	};

export const FREIGHT_DETAILS_DEFAULT: ShipmentFreightDetails = {
	lineItems: [],
	totalWeight: "0",
	totalHandlingUnits: "0",
	calculatedLinearFeet: null,
};

// A blank line item used to seed the Add Commodity modal.
export const BLANK_LINE_ITEM: ShipmentLineItem = {
	handlingUnit: null,
	unit: null,
	totalWeight: null,
	length: null,
	width: null,
	height: null,
	pieceCount: null,
	stackable: false,
	hazmat: false,
	commodityDescription: null,
	class: null,
	nmfc: null,
	density: null,
	estimatedClass: null,
	hazmatIdentificationNumber: null,
	hazmatProperShippingName: null,
	hazmatHazardClass: null,
	hazmatPackingGroup: null,
};

export const ADDITIONAL_DETAILS_DEFAULT = {
	emergencyContactName: null,
	emergencyContactNumber: null,
	agentPro: null,
	customerReference: null,
	soNumber: null,
	poNumber: null,
	loadValue: null,
	quoteSource: null,
	tenderSource: null,
	customerPONumber: null,
};

export const CARRIER_SERVICE_DEFAULT = {
	serviceLevel: null,
	serviceType: null,
	transitTime: null,
	liabilityPerPound: null,
	byClass: null,
	destinationTerminalCode: null,
	originTerminalCode: null,
	carrierId: null,
	scac: null,
};

export const CUSTOMER_DEFAULT = {
	customerRate: null,
	billingCustomer: null,
	tenderedCustomer: null,
	billedAmount: null,
	customerName: null,
	accountNumber: null,
	contact: {
		name: null,
		phone: null,
		email: null,
	},
	charges: null,
	totalCharges: null,
	primaryBroker: null,
	ltlBroker: null,
	isBillHoldCustomer: null,
};

export const CARRIER_DEFAULT = {
	carrierName: null,
	pro: null,
	agentPro: null,
	carrierRate: null,
	carrierQuoteId: null,
	expDate: null,
	contactInfo: {
		name: null,
		phone: null,
		extension: null,
		email: null,
	},
	charges: null,
};

export const REMARKS_DEFAULT = [
	{
		dateEntered: null,
		text: null,
		contactInfo: {
			name: null,
			phone: null,
			extension: null,
			email: null,
		},
	},
];
